import React from 'react';
import PropTypes from 'prop-types';

import Quote from 'models/quote';
import Event from 'models/event';

const propTypes = {
  selectedQuote: PropTypes.instanceOf(Quote),
  event: PropTypes.instanceOf(Event),
};

const defaultProps = {
  selectedQuote: new Quote(),
  event: null,
};

export const CheckoutHeadline = ({ selectedQuote, event }) => {
  if (event) {
    return (
      <div className="text-color-dark-slate text-size-16 text-weight-book margin-bottom-xs-20 margin-bottom-sm-0">
        <div className="margin-bottom-20 margin-top-xs-20 margin-top-sm-40">
          Complete the parking reservation for your event
        </div>
      </div>
    );
  }

  if (selectedQuote.isMonthly) {
    return (
      <div className="text-color-dark-slate text-size-16 margin-bottom-20 margin-top-xs-20 margin-top-sm-40">
        Complete your monthly parking reservation
      </div>
    );
  }

  return (
    <div className="text-color-dark-slate text-size-16 text-weight-book margin-bottom-20 margin-top-40">
      Complete your parking reservation
    </div>
  );
};

CheckoutHeadline.propTypes = propTypes;
CheckoutHeadline.defaultProps = defaultProps;

export default CheckoutHeadline;
